import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: absolute;
  padding-bottom: 100px;
  min-height: 100%;
  width: 100%;
`;

const LayoutWrapperUI = ({ children }) => (
  <Wrapper>{children}</Wrapper>
);

export default LayoutWrapperUI;



// WEBPACK FOOTER //
// ./src/components/ui/LayoutWrapperUI.js